/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, pxToRem, themeV2} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- REPORT BUILDER - ALL REPORT PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
    reportBuilder: {
        '& .sectiongroup': {
            width: '100%',
        },
        '& .column-name': {
            flexGrow: 2.75,
        },
        '& .column-metrics': {
            flexGrow: 0.75,
        },
        '& .collapsable.opened': {
            maxHeight: '100%'
        },
    },
    wrapper: {
        borderRadius: pxToEm(12),
        background: 'white',
        marginBottom: pxToEm(16),
        border: '1px solid #E7ECF7'

    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    actions: {
        maxWidth: pxToRem(112),
        display: 'flex',
        justifyContent: 'space-between',
        '& i': {
            width: pxToEm(10),
            height: pxToEm(10),
            cursor: 'pointer',
        },
        '& .name-exclamation': {
            color: themeV2.color.error.main,
            pointerEvents: 'none'
        },
        '& .name-arrow-down': {
            pointerEvents: 'none',
            opacity: '0',
            animationName: 'fadeInDown',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
        },
        '& .name-check': {
            color: themeV2.color.success.main,
            pointerEvents: 'none'
        },
        '& .name-clock': {
            color: themeV2.color.primary.main,
            pointerEvents: 'none'
        },
        '& .icon': {
            color: themeV2.color.base.gray.secondary,
            '& > .fa-trash':{
                color : '#DF1D1D'
            },
            '&:hover': {
                color: themeV2.color.primary.main
            },
            transition: 'color 0.2s ease-in-out',
        },


    },
    allReportsTable : {
        maxWidth: 'none',
    },
    allReportsTableHeader:{
        padding: '12px 12px 12px 30px !important',

            '& > .column-name':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            '& > .column-tablehead':{
            },
            '& > .column-frequency':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            '& > .column-endDate':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
    },
    allReportsTableBody : {
        maxWidth: 'none',
        '& > div': {
            padding: 'none',
            '& > .column-name':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            '& > .column-tablerow':{
            },
            '& > .column-frequency':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
                marginRight: pxToEm(-2),
            },
            '& > .column-endDate':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            '& > .column-recipients':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
                marginRight: pxToEm(-4),
            },
            '& > .column-creationDate':{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
                marginRight: pxToEm(-12),
            }

        }
    }
});
